import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

import { GenericEvents } from '../types/GenericEvents'
import type { ProductLocations } from '../types/ProductLocations'

const MIN_IMAGES_COUNT = 2

export function sendSwipeImagesEvent({
	colorId,
	productId,
	count,
	location,
}: {
	colorId: string
	productId: string
	count: number
	location: ProductLocations
}) {
	if (count >= MIN_IMAGES_COUNT) {
		sendGenericEvent(GenericEvents.PLP_ACTION, {
			label_1: `${GenericEvents.SWIPE_IMAGES_PREFIX}_${count}`,
			color: colorId,
			product_id: productId,
			location,
		})
	}
}
